import {FormControl} from '@angular/forms';

declare let ContainerValidator: any;

export class BasicValidators {

  static email (control: FormControl){
    let EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return EMAIL_REGEXP.test(control.value) ? null : {
      validateEmail: {
        valid: false
      }
    };
  }

  static igualSenha(control: FormControl){

    if(control.value == undefined || control.value == ''){
      return null;
    }

    return (control.root.value['senha'] == control.value) ? null : {
      igual: {
        valid: false
      }
    };
  }

  static containerNumber(control: FormControl){

    if(control.value == undefined || control.value == ''){
      return null;
    }

    let validator = new ContainerValidator();
    let numero = control.value.replace(/-/g,'');

    if(!validator.isValid(numero)){
      return {
        containerNumber: {
          valid: false
        }
      };
    }else{
      return null;
    }
  }

  static diferenteZero(control: FormControl){

    if(control.value == undefined || control.value === '' || control.value == null){
      return null;
    }

    let val = control.value;
    if (typeof val === 'string') {
      val = parseFloat(val.replace(/\./g, '').replace(',', '.'));
    }

    return (0 != val && !isNaN(val)) ? null : {
        diferenteZero: {
          valid: false
        }
      };
  }

  static notNull(control: FormControl){
    return (control.value != null && control.value !== 'null' && control.value !== '' && control.value !== undefined) ? null : {
      notNull: {
        valid: false
      }
    };
  }

  static cnpj(control: FormControl) {
    if (control.value == undefined || control.value == null || control.value == '') {
      return null;
    }

    let cnpj = control.value.replace(/[^\d]+/g, '');

    if (cnpj.length !== 14) {
      return { validateCnpj: { valid: false } };
    }

    if (/^(\d)\1+$/.test(cnpj)) {
      return { validateCnpj: { valid: false } };
    }

    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += parseInt(numeros.charAt(tamanho - i), 10) * pos--;
      if (pos < 2) pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != parseInt(digitos.charAt(0), 10)) {
      return { validateCnpj: { valid: false } };
    }

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += parseInt(numeros.charAt(tamanho - i), 10) * pos--;
      if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != parseInt(digitos.charAt(1), 10)) {
      return { validateCnpj: { valid: false } };
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/basic-validators.ts